import { render, staticRenderFns } from "./AkCurrencyField.vue?vue&type=template&id=1c1eb10e&"
import script from "./AkCurrencyField.vue?vue&type=script&lang=js&"
export * from "./AkCurrencyField.vue?vue&type=script&lang=js&"
import style0 from "./AkCurrencyField.vue?vue&type=style&index=0&id=1c1eb10e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports